const { Component, Fragment } = wp.element;

class Palette extends Component {
    is_saved = localStorage.getItem("wp_dark_mode_gb");

    state = {
        type: !!this.is_saved ? this.is_saved : "default",
    };

    handleColorPalette(type) {
        const elm = document.getElementsByTagName("html")[0];
        const img = document.getElementById("wpDarkModeThemeSwitchImg");

        elm.classList.remove(
            "wp-dark-mode-theme-default",
            "wp-dark-mode-theme-darkmode",
            "wp-dark-mode-theme-chathams",
            "wp-dark-mode-theme-pumpkin",
            "wp-dark-mode-theme-mustard",
            "wp-dark-mode-theme-concord"
        );
        elm.classList.add(`wp-dark-mode-theme-${type}`);

        img.setAttribute(
            "src",
            `${wp_dark_mode_admin_json.url.plugin}/includes/modules/gutenberg/images/${type}.png`
        );

        this.setState({ type: type });
        localStorage.setItem("wp_dark_mode_gb", type);



        // Set active false.
        this.setState({ active: false });
    }

    render() {
        const { type } = this.state;

        const labels = {
            default: "Default",
            darkmode: "Darkmode",
            chathams: "Chathams",
            pumpkin: "Pumpkin Spice",
            mustard: "Mustard Seed",
            concord: "Concord Jam",
        };

        const is_pro = wp_dark_mode_admin_json.is_ultimate;

        return (
            <div className="wpdm-color-palettes-wrapper">
                {Object.entries(labels).map(([key, label], i) => (
                    <a
                        href="javascript:;"
                        className={`${type == key ? "active" : ""} ${
                            !is_pro &&
                            key !== "default" &&
                            key !== "darkmode" &&
                            "disabled"
                        }`}
                        onClick={() => {
                            if (
                                !is_pro &&
                                key !== "default" &&
                                key !== "darkmode"
                            ) {
                                document
                                    .querySelector(".wp-dark-mode-promo")
                                    .classList.remove("hidden");
                                return;
                            }

                            this.handleColorPalette(key);
                        }}
                    >
                        <img
                            src={`${wp_dark_mode_admin_json.url.plugin}/includes/modules/gutenberg/images/${key}.png`}
                            alt={label}
                        />
                        <span> {label} </span>
                        {type == key ? <span className="tick"> ✓ </span> : ""}

                        {!is_pro && key !== "default" && key !== "darkmode" && (
                            <span className="wp-darkmode-pro-badge"> PRO </span>
                        )}
                    </a>
                ))}
            </div>
        );
    }
}

class ColorPalettes extends Component {
    render() {
        const { active } = this.props;

        return (
            <Fragment>
                {active ? (
                    <div className="wp-dark-mode-block-colors">
                        <Palette />
                    </div>
                ) : (
                    ""
                )}
            </Fragment>
        );
    }
}

export default ColorPalettes;
